// extracted by mini-css-extract-plugin
module.exports = {"systemWrapper":"GraphData_systemWrapper__lmaX6","systemsList":"GraphData_systemsList__9gmTM"};